import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Text, Flex, Button, Divider } from "@chakra-ui/react";

import Topbar from "components/topbar";
import MainLayout from "components/mainLayout";
import { useShipmentForm } from "context/DHLShipmentFormContext";

const ShipmentDhlMethod = () => {
  const navigate = useNavigate();
  const { formData, updateFormData } = useShipmentForm();
  const [value, setValue] = useState(() => {
    if (formData?.dropoff?.howTo === "service-point") {
      return "dhl_service_point";
    } else if (formData?.dropoff?.howTo === "printer") {
      return "print_label";
    } else {
      return ""; // or a default value if neither condition is met
    }
  });

  return (
    <MainLayout>
      <Flex minH={"100%"} h={"100%"} bg={"#f8fbff"} flexDirection={"column"}>
        <Topbar title={"SHIP THROUGH DHL"} />
        <Flex
          flex={1}
          direction={"column"}
          bg={"#FFFFFF"}
          margin={4}
          padding={6}
          borderRadius={"16px"}
          gap={6}
        >
          {/* <Box> */}
          <Text
            fontFamily={"PlusJakartaSansSemiBold"}
            fontSize={"24px"}
            lineHeight={"32px"}
            textTransform={"capitalize"}
            color={"#000000"}
          >
            Create Shipment
          </Text>
          <Divider bg={"#8A8F9333"} h={"1px"} />
          <Box>
            <Box>
              <Text
                fontFamily={"PlusJakartaSansSemiBold"}
                fontSize={"16px"}
                lineHeight={"20px"}
                color={"#000000"}
              >
                Label Printing Options
              </Text>
              <Flex
                gap={4}
                marginTop={2}
                borderWidth={"1px"}
                borderColor={"#D9D9D9"}
                borderStyle={"solid"}
                padding={4}
                borderRadius={"6px"}
                flexDirection={"column"}
              >
                <Box
                  border="1px solid"
                  borderColor={
                    value === "dhl_service_point" ? "#456EFF" : "gray.300"
                  }
                  bg={value === "dhl_service_point" ? "#456EFF0D" : "white"}
                  borderRadius="4px"
                  p="4"
                  cursor="pointer"
                  onClick={() => setValue("dhl_service_point")}
                >
                  <Flex align="center" justifyContent={"space-between"}>
                    <Box>
                      <Text
                        fontSize={"16px"}
                        fontFamily={"PlusJakartaSansSemiBold"}
                        color={"#000000"}
                      >
                        At DHL service point
                      </Text>
                      <Text
                        fontSize={"12px"}
                        fontFamily={"PlusJakartaSansRegular"}
                        color={"#898989"}
                        mt={1}
                      >
                        Get a QR code to print label at a DHL Service Point
                      </Text>
                    </Box>
                  </Flex>
                </Box>
                <Box
                  border="1px solid"
                  borderColor={value === "print_label" ? "#456EFF" : "gray.300"}
                  bg={value === "print_label" ? "#456EFF0D" : "white"}
                  borderRadius="4px"
                  p="4"
                  cursor="pointer"
                  onClick={() => setValue("print_label")}
                >
                  <Flex align="center" justifyContent={"space-between"}>
                    <Box>
                      <Text
                        fontSize={"16px"}
                        fontFamily={"PlusJakartaSansSemiBold"}
                        color={"#000000"}
                      >
                        On my printer
                      </Text>
                      <Text
                        fontSize={"12px"}
                        fontFamily={"PlusJakartaSansRegular"}
                        color={"#898989"}
                        mt={1}
                      >
                        Print label and affix to the shipment
                      </Text>
                    </Box>
                  </Flex>
                </Box>
              </Flex>
            </Box>
          </Box>
          <Flex mt={4} gap={2} flex={1} alignItems={"flex-end"}>
            <Flex>
              <Button
                onClick={() => navigate(-1)}
                width={"148px"}
                borderRadius={8}
                bg={"none"}
                border={"1px solid #000000"}
                color={"#000000"}
                fontSize={"12px"}
                fontWeight={"500"}
                fontFamily={"PlusJakartaSansMedium"}
                letterSpacing={0.2}
              >
                Back
              </Button>
            </Flex>
            <Flex justifyContent={"flex-end"} flex={1} w={"100%"} gap={2}>
              <Button
                onClick={() => {
                  if (value === "dhl_service_point") {
                    updateFormData({
                      dropoff: {
                        howTo: "service-point",
                        servicePoint: {
                          postalCode:
                            formData?.dropoff?.servicePoint?.postalCode,
                          countryCode:
                            formData?.dropoff?.servicePoint?.countryCode,
                          point: {
                            id: formData?.dropoff?.servicePoint?.point?.id,
                            name: formData?.dropoff?.servicePoint?.point?.name,
                            address:
                              formData?.dropoff?.servicePoint?.point?.address,
                          },
                        },
                        notifications: [
                          {
                            email:
                              formData?.dropoff?.notifications &&
                              formData?.dropoff?.notifications[0]?.email,
                            phone:
                              formData?.dropoff?.notifications &&
                              formData?.dropoff?.notifications[0]?.phone,
                          },
                        ],
                      },
                    });
                    navigate("/send-a-bag/dhl/drop-at-location");
                  }
                  if (value === "print_label") {
                    updateFormData({
                      dropoff: {
                        howTo: "printer",
                        servicePoint: {
                          postalCode:
                            formData?.dropoff?.servicePoint?.postalCode,
                          countryCode:
                            formData?.dropoff?.servicePoint?.countryCode,
                          point: {
                            id: formData?.dropoff?.servicePoint?.point?.id,
                            name: formData?.dropoff?.servicePoint?.point?.name,
                            address:
                              formData?.dropoff?.servicePoint?.point?.address,
                          },
                        },
                      },
                    });
                    navigate("/send-a-bag/dhl/drop-at-location");
                  }
                }}
                flex={1}
                maxW={"148px"}
                background={"#000000"}
                color={"#FFFFFF"}
                borderRadius={8}
                fontSize={"12px"}
                fontFamily={"PlusJakartaSansMedium"}
                textTransform={"uppercase"}
                // isDisabled={}
                _disabled={{
                  bg: "grey.100",
                  cursor: "default",
                  _hover: {
                    bg: "grey.100",
                    cursor: "default",
                  },
                }}
              >
                Next
              </Button>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </MainLayout>
  );
};

export default ShipmentDhlMethod;
